import React, { Component } from 'react';
import { bool, func, number, object, shape, string, array, oneOfType } from 'prop-types';
import { withRouter } from 'react-router';
import classnames from 'classnames';
import { Dropdown, Modal, Toggle, Tooltip } from 'ps-design';
import { Button } from '@mantine/core';
import { Link } from 'react-router-dom';
import ModalBody from 'ps-components/Modal/ModalBody/ModalBody';
import ModalHeader from 'ps-components/Modal/ModalHeader/ModalHeader';
import ModalFooter from 'ps-components/Modal/ModalFooter/ModalFooter';
import RangeDropdown from './RangeDropdown/RangeDropdown';
import { shortDateString } from 'ps-components/lib/formatters';
import { SLIDEOUTS as PS_SLIDEOUTS } from 'ps-components/Slideout/Slideouts';
import { SLIDEOUTS as MarketPaySlideouts } from '../../../components/Slideout/Slideouts';

import JobPricingDetails from '../JobPricingDetails/JobPricingDetails';
import { PRICING_TYPE } from '../../SkillGeoDifferential/SkillGeoDifferentialReducer';
import { isAdHocJobId } from '../helper';
import { getColumnIndex } from 'ps-components/AdvancedTable/GenericGrid/GenericGridHelper';
import GG_DEFAULTS from '../../../lib/genericGridDefaults';

import './JobPricingContainer.scss';

export const OVERALL_COLLAPSE_KEY = 'market_pricing_job_collapse_overall';
export const OVERALL_SLOTTED_COLLAPSE_KEY = 'market_pricing_slotted_job_collapse_overall';
export const RANGE_CHART_KEY = 'market_pricing_range_chart';
export const COLLAPSE_KEY = 'market_pricing_job_collapse';
export const CURRENT_JOB_KEY = 'market_pricing_current_job';
export const GENDER_TOGGLE_KEY = 'market_pricing_gender_display';

function getWeightingLabel(code) {
  const mapping = {
    one: 'Equal Weighting (1)',
    companies: 'Weight by # of Companies',
    employees: 'Weight by # of Employees',
    zero: '0 Weighting'
  };

  return mapping[code] || 'Not Set';
}

class JobPricingContainer extends Component {
  static propTypes = {
    deleteMatch: func,
    jobMatchGridActions: object,
    showSlideout: func,
    updatePricingData: func,
    updateJobMatchesValues: func,
    monetaryRounding: number,
    percentRounding: number,
    numericRounding: number,
    isPricingMatchDeleting: bool,
    isPricingMatchDeleteFailed: bool,
    selectedBenchmarkYear: number,
    activeBenchmarkYear: number,
    isJobMatchUpdateFailed: bool,
    isJobMatchUpdating: bool,
    isGetJobPricingLoading: bool,
    isGetJobPricingFailed: bool,
    isUpdatingAgingFactor: bool,
    isUpdatingAgingFactorFailed: bool,
    onPricingChange: func,
    currentJob: shape({
      id: number,
      code: string,
      codeKey: string
    }),
    getConfigSettings: func,
    readOnlyUser: bool,
    showYearOverYearSlideout: func,
    showDifferentialsSlideout: func,
    updateMeritMatchSummaries: func,
    togglePopover: func,
    renderPopover: bool,
    selectedRowId: number,
    reportDropdownOption: string,
    location: object,
    jobPricingGrid: object,
    jobPricingGridActions: object,
    jobPricing: object,
    benchmarkYear: number,
    displayIn: string,
    masterAccountId: oneOfType([number, string]),
    getJobPricingDetails: func,
    selectedViewPk: number,
    selectedViewSlottedPk: number,
    onDataCutClick: func,
    isSavingDataCutChangesComplete: bool,
    isUpdatingMeritMatchSummaries: bool,
    isUpdatingMeritMatchSummariesFailed: bool,
    useJobCodeKey: bool,
    selectedSurveys: array,
    onSurveyJobTitleClick: func,
    getSurveyJobDetailsPageHref: func,
    getSlottedJobPageHref: func,
    updateModifiedDate: func,
    renderBenchmarkYearDropdown: func,
    renderAgingDropdown: func,
    siteSettings: shape({
      showAgingFactor: bool,
      showWgtBy: bool,
      useParticipationMatch: bool,
      showGeoAdjustment: bool
    }),
    isSlottedJob: bool,
    isOnSlotPage: bool,
    getRangeChartData: func,
    rangeChartData: object,
    rangeChartLoading: bool,
    rangeChartLoaded: bool,
    rangeChartError: bool,
    openCompSummary: func,
    getPricingDetailsForSlottedJob: func,
    selectedSlottedJobs: array,
    defaultWeighting: string,
    isReadOnly: bool,
    isEditPastYears: bool,
    uniqueSalaryRange: bool,
    featureFlags: object,
    isPriced: func,
    restrictedUser: bool
  };

  constructor(props) {
    super(props);

    this.deleteMatch = this.deleteMatch.bind(this);
    this.showDeleteModal = this.showDeleteModal.bind(this);
    this.hideDeleteModal = this.hideDeleteModal.bind(this);
    this.handleOnSurveySave = this.handleOnSurveySave.bind(this);
    this.contactSupport = this.contactSupport.bind(this);
    this.handleOnUpdateMeritMatchSummaries = this.handleOnUpdateMeritMatchSummaries.bind(this);
    this.toggleOverallDetails = this.toggleOverallDetails.bind(this);
    this.toggleSlottedDetails = this.toggleSlottedDetails.bind(this);
    this.toggleRangeChart = this.toggleRangeChart.bind(this);
    this.closeRangeChart = this.closeRangeChart.bind(this);
    this.openDifferentials = this.openDifferentials.bind(this);
    this.weightByCos = this.weightByCos.bind(this);
    this.weightByEes = this.weightByEes.bind(this);
    this.weightEqually = this.weightEqually.bind(this);
    this.getIndex = this.getIndex.bind(this);
    this.updateGrid = this.updateGrid.bind(this);
    this.deleteModal = React.createRef();
    this.showRangeSlideout = this.showRangeSlideout.bind(this);
    this.toggleGenderOnRangeChart = this.toggleGenderOnRangeChart.bind(this);

    this.state = {
      matchToDelete: null,
      recentDeletedMatchId: null,
      toggleDetails: window.localStorage.getItem(OVERALL_COLLAPSE_KEY) === 'true',
      toggleSlottedDetails: window.localStorage.getItem(OVERALL_SLOTTED_COLLAPSE_KEY) === 'true',
      rangeChart: window.localStorage.getItem(RANGE_CHART_KEY) === 'true',
      genderToggle: window.localStorage.getItem(GENDER_TOGGLE_KEY) === 'true',
    };

    this.toggleSlottedDetails(this.state.toggleSlottedDetails);
  }

  componentDidMount() {
    const { getRangeChartData, currentJob, benchmarkYear, displayIn, location, openCompSummary } = this.props;
    getRangeChartData(currentJob.code, currentJob.codeKey, benchmarkYear);
    if (location?.pathname.includes('compensation-summary-report')) {
      openCompSummary();
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {
      isSavingDataCutChangesComplete,
      selectedSurveys,
      currentJob,
      benchmarkYear,
      getRangeChartData,
      jobPricingGrid
    } = this.props;

    if (
      prevProps.selectedSurveys.length !== selectedSurveys.length ||
      prevProps.jobPricingGrid.summaryData !== jobPricingGrid.summaryData
    )
      getRangeChartData(currentJob.code, currentJob.codeKey, benchmarkYear);

    if (!prevProps.isSavingDataCutChangesComplete && isSavingDataCutChangesComplete) {
      this.setState({ recentDeletedMatchId: null });
    }

    if (
      this.props.isOnSlotPage &&
      (prevProps.benchmarkYear !== this.props.benchmarkYear ||
        prevProps.selectedSlottedJobs !== this.props.selectedSlottedJobs)
    ) {
      this.toggleSlottedDetails(this.state.toggleSlottedDetails);
    }
  }

  showDeleteModal(matchId) {
    this.setState({ matchToDelete: { matchId } }, this.deleteModal?.current.show);
  }

  hideDeleteModal() {
    this.deleteModal?.current.hide();
  }

  toggleOverallDetails() {
    const currentValue = this.state.toggleDetails;
    window.localStorage.setItem(OVERALL_COLLAPSE_KEY, !currentValue);
    this.setState({ toggleDetails: !currentValue });
  }

  showRangeSlideout() {
    const { showSlideout, currentJob } = this.props;
    showSlideout(MarketPaySlideouts.SALARY_RANGE_SLIDEOUT, { orgJobId: currentJob.id });
  }

  toggleSlottedDetails(newToggleValue) {
    const {
      jobPricingGridActions,
      selectedSlottedJobs,
      benchmarkYear,
      displayIn,
      masterAccountId,
      currentJob,
      jobPricingGrid
    } = this.props;

    jobPricingGridActions.toggleAllSubRows(
      benchmarkYear,
      displayIn,
      masterAccountId,
      currentJob?.currency,
      jobPricingGrid,
      jobPricingGridActions,
      selectedSlottedJobs,
      newToggleValue
    );

    window.localStorage.setItem(OVERALL_SLOTTED_COLLAPSE_KEY, newToggleValue);
    this.setState({ toggleSlottedDetails: newToggleValue });
  }

  toggleRangeChart() {
    const currentValue = this.state.rangeChart;
    window.localStorage.setItem(RANGE_CHART_KEY, !currentValue);
    this.setState({ rangeChart: !currentValue });
  }

  toggleGenderOnRangeChart(){
    const currentValue = this.state.genderToggle;
    window.localStorage.setItem(GENDER_TOGGLE_KEY, !currentValue);
    this.setState({ genderToggle: !currentValue}, () => {
    });
  }

  closeRangeChart() {
    window.localStorage.setItem(RANGE_CHART_KEY, false);
    this.setState({ rangeChart: false });
  }

  updateGrid() {
    const {
      currentJob,
      benchmarkYear,
      displayIn,
      masterAccountId,
      jobPricingGridActions,
      jobPricingGrid,
      getJobPricingDetails,
      updateModifiedDate
    } = this.props;

    if (!jobPricingGrid.loading) {
      getJobPricingDetails(currentJob, benchmarkYear, displayIn, jobPricingGridActions.search, masterAccountId);
      updateModifiedDate(currentJob?.id, benchmarkYear);
    }
  }

  openDifferentials() {
    const { showDifferentialsSlideout, currentJob } = this.props;
    if (currentJob?.currency === 'USD') {
      showDifferentialsSlideout();
    }
  }

  getIndex(name) {
    const { jobPricingGrid } = this.props;
    return jobPricingGrid?.terms?.findIndex(term => term.term === name);
  }

  weightByCos() {
    const {
      updateMeritMatchSummaries,
      updateJobMatchesValues,
      jobPricingGrid,
      currentJob,
      selectedBenchmarkYear,
      isEditPastYears
    } = this.props;
    const cosIndex = this.getIndex('total_companies_default'),
      adjIndex = this.getIndex('data_adjustment_factor_default'),
      geoIndex = this.getIndex('geo_adj_factor_default'),
      matchIdIndex = this.getIndex('match_id_default');

    updateMeritMatchSummaries(currentJob.id, undefined, undefined, selectedBenchmarkYear, isEditPastYears);

    updateJobMatchesValues(
      currentJob.id,
      jobPricingGrid.data.map(match => {
        return {
          matchId: match[matchIdIndex],
          adj: match[adjIndex],
          geo: match[geoIndex],
          wgt: match[cosIndex] || 0
        };
      }),
      {},
      selectedBenchmarkYear,
      isEditPastYears
    ).then(this.updateGrid);
  }

  weightByEes() {
    const {
      updateMeritMatchSummaries,
      updateJobMatchesValues,
      jobPricingGrid,
      currentJob,
      selectedBenchmarkYear,
      isEditPastYears
    } = this.props;
    const eesIndex = this.getIndex('total_incumbents_default'),
      adjIndex = this.getIndex('data_adjustment_factor_default'),
      geoIndex = this.getIndex('geo_adj_factor_default'),
      matchIdIndex = this.getIndex('match_id_default');

    updateMeritMatchSummaries(currentJob.id, undefined, undefined, selectedBenchmarkYear, isEditPastYears);

    updateJobMatchesValues(
      currentJob.id,
      jobPricingGrid.data.map(match => {
        return {
          matchId: match[matchIdIndex],
          adj: match[adjIndex],
          geo: match[geoIndex],
          wgt: match[eesIndex] || 0
        };
      }),
      {},
      selectedBenchmarkYear,
      isEditPastYears
    ).then(this.updateGrid);
  }

  weightEqually() {
    const {
      updateMeritMatchSummaries,
      updateJobMatchesValues,
      jobPricingGrid,
      currentJob,
      selectedBenchmarkYear,
      isEditPastYears
    } = this.props;
    const adjIndex = this.getIndex('data_adjustment_factor_default'),
      geoIndex = this.getIndex('geo_adj_factor_default'),
      matchIdIndex = this.getIndex('match_id_default');

    updateMeritMatchSummaries(currentJob.id, undefined, undefined, selectedBenchmarkYear, isEditPastYears);

    updateJobMatchesValues(
      currentJob.id,
      jobPricingGrid.data.map(match => {
        return {
          matchId: match[matchIdIndex],
          adj: match[adjIndex],
          geo: match[geoIndex],
          wgt: 1
        };
      }),
      {},
      selectedBenchmarkYear,
      isEditPastYears
    ).then(this.updateGrid);
  }

  handleOnUpdateMeritMatchSummaries(adjustment, comment) {
    const { currentJob, updateMeritMatchSummaries, selectedBenchmarkYear, isEditPastYears } = this.props;
    return updateMeritMatchSummaries(
      currentJob.id,
      Number(adjustment),
      comment,
      selectedBenchmarkYear,
      isEditPastYears
    );
  }

  contactSupport() {
    const { showSlideout } = this.props;
    showSlideout(PS_SLIDEOUTS.CONTACT_SUPPORT_SLIDEOUT);
  }

  handleOnSurveySave(updatedSurvey) {
    const {
      currentJob,
      updateMeritMatchSummaries,
      updateJobMatchesValues,
      onPricingChange,
      selectedBenchmarkYear,
      isEditPastYears
    } = this.props;
    const match = {
      matchId: updatedSurvey.matchId,
      ...updatedSurvey.surveyAdjustmentFactors
    };
    if (updatedSurvey.matchComments !== null && typeof updatedSurvey.matchComments !== 'undefined') {
      // Allow empty string for case where user is deleting a comment
      match.comment = updatedSurvey.matchComments;
    }

    updateMeritMatchSummaries(currentJob.id, undefined, undefined, selectedBenchmarkYear, isEditPastYears);

    return updateJobMatchesValues(currentJob.id, [match], {}, selectedBenchmarkYear, isEditPastYears).then(data => {
      if (onPricingChange && data.isSummaryUpdated) {
        onPricingChange(currentJob);
      }
    });
  }

  deleteMatch() {
    const {
      deleteMatch,
      selectedBenchmarkYear,
      currentJob,
      onPricingChange,
      updateModifiedDate,
      isSlottedJob,
      jobPricingGrid,
      jobMatchGridActions
    } = this.props;
    const { matchToDelete } = this.state;

    let slottedInfo;
    if (isSlottedJob) {
      const matchIdIndex = getColumnIndex(jobPricingGrid, 'match_id_default');
      const slotJobId = getColumnIndex(jobPricingGrid, GG_DEFAULTS.ORG_JOB_ID);
      const slotJobCodeIndex = getColumnIndex(jobPricingGrid, GG_DEFAULTS.ORG_JOB_CODE);
      const slotJobCodeKeyIndex = getColumnIndex(jobPricingGrid, GG_DEFAULTS.ORG_JOB_CODE_KEY);

      const selectedSlottedJob = jobPricingGrid.data.find(job => job[matchIdIndex] === matchToDelete.matchId);

      slottedInfo = {
        slottedOrgJobId: selectedSlottedJob[slotJobId],
        slottedOrgJobCode: selectedSlottedJob[slotJobCodeIndex],
        slottedOrgJobCodeKey: selectedSlottedJob[slotJobCodeKeyIndex]
      };
    }

    deleteMatch(currentJob.id, null, [matchToDelete.matchId], selectedBenchmarkYear, false, slottedInfo).then(() => {
      jobMatchGridActions.setIsStale(currentJob.id, true);
      updateModifiedDate(currentJob.id, selectedBenchmarkYear);
      this.hideDeleteModal();
      // Add recent deleted match to pass to JobPricingDetails to detect change
      this.setState({ recentDeletedMatchId: matchToDelete.matchId });
      if (onPricingChange) {
        onPricingChange(currentJob);
      }
    });
  }

  getPricingMatchTitleFromId(matchId) {
    const { jobPricingGrid } = this.props;
    const titleIndex = jobPricingGrid.terms.findIndex(
      term => term.term === 'job_title_default' || term.term === 'org_job_title_default'
    );
    const matchIdIndex = jobPricingGrid.terms.findIndex(term => term.term === 'match_id_default');
    if (matchIdIndex !== -1 && titleIndex !== -1) {
      const match = jobPricingGrid.data.find(match => match[matchIdIndex] === matchId);
      if (match) {
        return match[titleIndex];
      }
    }
    return '';
  }

  hasJobDetails() {
    const { jobPricingGrid } = this.props;
    return jobPricingGrid.data?.length > 0;
  }

  render() {
    const {
      activeBenchmarkYear,
      benchmarkYear,
      currentJob,
      defaultWeighting,
      displayIn,
      getPricingDetailsForSlottedJob,
      getSlottedJobPageHref,
      getSurveyJobDetailsPageHref,
      isEditPastYears,
      isGetJobPricingLoading,
      isJobMatchUpdating,
      isOnSlotPage,
      isPriced,
      isPricingMatchDeleteFailed,
      isPricingMatchDeleting,
      isReadOnly,
      isSavingDataCutChangesComplete,
      isSlottedJob,
      jobMatchGridActions,
      jobPricing,
      jobPricingGrid,
      jobPricingGridActions,
      masterAccountId,
      numericRounding,
      onDataCutClick,
      onSurveyJobTitleClick,
      percentRounding,
      rangeChartData,
      rangeChartError,
      rangeChartLoaded,
      rangeChartLoading,
      readOnlyUser,
      renderAgingDropdown,
      renderBenchmarkYearDropdown,
      renderPopover,
      reportDropdownOption,
      selectedBenchmarkYear,
      selectedRowId,
      selectedSurveys,
      selectedViewPk,
      selectedViewSlottedPk,
      showYearOverYearSlideout,
      siteSettings,
      togglePopover,
      updateModifiedDate,
      useJobCodeKey,
      usePropagateMatches,
      uniqueSalaryRange,
      restrictedUser
    } = this.props;

    const { matchToDelete, toggleDetails, toggleSlottedDetails, rangeChart, genderToggle } = this.state;
    const showDifferentials = currentJob?.currency === 'USD';
    const isAdHocJob = isAdHocJobId(currentJob.id);
    const differentialTooltipText = isAdHocJob
      ? 'Differentials is not available for adhoc jobs'
      : 'Differentials is only available for USD jobs';
    const ageToIndex = jobPricingGrid.terms.findIndex(
      term => term.term === 'aging_date' || term.term === 'aging_date_default'
    );

    return (
      <div className="job-pricing__container">
        <div className="pricing__header">
          {!jobPricingGrid.processInitialLoad ? (
            <div className="pricing-job-data">
              {renderBenchmarkYearDropdown()}
              {renderAgingDropdown()}
              {ageToIndex > -1 && jobPricingGrid.data?.length > 0 && (
                <span className="pricing-age-to-date">
                  Age to {shortDateString(new Date(jobPricingGrid.data[0][ageToIndex].replace(/-/g, '/')))}
                </span>
              )}
              {!isOnSlotPage && (
                <div className="job-pricing__toggle-container">
                  <Toggle
                    onChange={this.toggleOverallDetails}
                    id="job-pricing__toggle-details"
                    className="job-pricing__toggle"
                    value={toggleDetails}
                  />
                  <span className="job-pricing__toggle-text">Show Details</span>
                </div>
              )}

              {isOnSlotPage && (
                <div className="job-pricing__toggle-container">
                  <Toggle
                    onChange={() => this.toggleSlottedDetails(!toggleSlottedDetails)}
                    id="job-pricing__toggle-details-slotted"
                    className="job-pricing__toggle slotted"
                    value={toggleSlottedDetails}
                  />
                  <span className="job-pricing__toggle-text">Show matches</span>
                </div>
              )}

              <div className="job-pricing__toggle-container">
                <Toggle
                  onChange={this.toggleRangeChart}
                  id="job-pricing__toggle-range-chart"
                  className="job-pricing__toggle"
                  value={rangeChart}
                />
                <span className="job-pricing__toggle-text">Show range chart</span>
              </div>

              <div className="job-pricing__toggle-container">
                <Toggle
                  onChange={this.toggleGenderOnRangeChart}
                  id="job-pricing__toggle-gender-toggle"
                  className="job-pricing__toggle"
                  value={genderToggle}
                />
                <span className="job-pricing__toggle-text">Show employee gender</span>
              </div>

            </div>
          ) : (
            <div className="pricing-job-data-loading"></div>
          )}
          {this.hasJobDetails() && (
            <div className="pricing-actions">
              {uniqueSalaryRange ? (
                <Button
                  onClick={this.showRangeSlideout}
                  size="lg"
                  variant="outline"
                >
                   Assign Salary Range
                </Button>
              ) : null}
              {usePropagateMatches && useJobCodeKey && !readOnlyUser && !restrictedUser && !isAdHocJob && !isSlottedJob && isPriced &&(
                <Button
                  component={Link}
                  to={{pathname:'/market-analysis/propagate-matches', state: {jobID: currentJob.id}}}
                  size="lg"
                  variant="outline"
                >
                  Propagate Matches
                </Button>
              )}
              {!readOnlyUser && (
                <Dropdown
                  btnText="Adjust Pricing"
                  dropdownClass={classnames('pricing-dropdown__adjust', {
                    'adhoc-position': isAdHocJob
                  })}
                >
                  <a
                    className={classnames('pxl-dropdown__item pricing-dropdown__differentials', {
                      disabled: !showDifferentials
                    })}
                    title={showDifferentials ? undefined : differentialTooltipText}
                    onMouseDown={this.openDifferentials}
                  >
                    Differentials
                  </a>
                  {siteSettings.showWgtBy && !isOnSlotPage && (
                    <div className="market-pricing__weighting-options-container">
                      <Tooltip
                        className="system-default-icon"
                        hoverText={`System Default: ${getWeightingLabel(defaultWeighting)}`}
                        id="system-default-icon"
                        position="bottom"
                      />

                      <Dropdown
                        btnText="Weighting Options"
                        dropdownClass="pricing-dropdown__weight-by pxl-dropdown__item"
                        btnClass="clear-btn"
                        closeOnChildClick={true}
                      >
                        <a
                          className="pxl-dropdown__item pricing-dropdown__weight-by-cos"
                          onMouseDown={this.weightByCos}
                        >
                          by Cos
                        </a>
                        <a
                          className="pxl-dropdown__item pricing-dropdown__weight-by-ees"
                          onMouseDown={this.weightByEes}
                        >
                          by Ees
                        </a>
                        <a
                          className="pxl-dropdown__item pricing-dropdown__weight-by-equal"
                          onMouseDown={this.weightEqually}
                        >
                          Equally (1)
                        </a>
                      </Dropdown>
                    </div>
                  )}
                </Dropdown>
              )}
              {!isAdHocJob && (
                <Button
                  onClick={showYearOverYearSlideout}
                  size="lg"
                  variant="outline"
                >
                  Year Over Year
                </Button>
              )}
            </div>
          )}
        </div>
        {this.hasJobDetails() && (
          <RangeDropdown
            className={classnames({ open: rangeChart })}
            rangeChartData={rangeChartData}
            rangeChartLoading={rangeChartLoading}
            rangeChartLoaded={rangeChartLoaded}
            rangeChartError={rangeChartError}
            displayIn={displayIn}
            genderToggle={genderToggle}
            closeRangeChart={this.closeRangeChart}
          />
        )}
        <div
          className={classnames('pricing-details__container', {
            loaded: !jobPricingGrid.processInitialLoad && jobPricingGrid.data?.length > 0,
            adhoc: isAdHocJob,
            'range-show': rangeChart
          })}
        >
          <React.Fragment>
            {reportDropdownOption !== 'Compensation Summary' && (
              <JobPricingDetails
                activeBenchmarkYear={activeBenchmarkYear}
                aging={jobPricing?.selectedAgingFactor}
                benchmarkYear={benchmarkYear}
                displayIn={displayIn}
                editPastYears={isEditPastYears}
                getPricingDetailsForSlottedJob={getPricingDetailsForSlottedJob}
                getSlottedJobPageHref={getSlottedJobPageHref}
                getSurveyJobDetailsPageHref={getSurveyJobDetailsPageHref}
                hasJobDetails={this.hasJobDetails()}
                isAdHocJob={isAdHocJob}
                isOnSlotPage={isOnSlotPage}
                isSavingDataCutChangesComplete={isSavingDataCutChangesComplete}
                job={currentJob}
                jobPricing={jobPricing}
                jobPricingGrid={jobPricingGrid}
                jobPricingGridActions={jobPricingGridActions}
                loading={isGetJobPricingLoading || isJobMatchUpdating}
                masterAccountId={masterAccountId}
                numericRounding={numericRounding}
                onDataCutClick={onDataCutClick}
                onDelete={this.showDeleteModal}
                onMeritMatchSummariesSave={this.handleOnUpdateMeritMatchSummaries}
                onSurveyJobTitleClick={onSurveyJobTitleClick}
                onSurveySave={this.handleOnSurveySave}
                overallToggleDetails={toggleDetails}
                percentRounding={percentRounding}
                readOnly={isReadOnly}
                recentDeletedCutId={this.state.recentDeletedCutId}
                renderPopover={renderPopover}
                selectedBenchmarkYear={selectedBenchmarkYear}
                selectedRowId={selectedRowId}
                selectedSurveys={selectedSurveys}
                selectedViewPk={isOnSlotPage ? selectedViewSlottedPk : selectedViewPk}
                siteSettings={siteSettings}
                togglePopover={togglePopover}
                updateGrid={this.updateGrid}
                updateModifiedDate={updateModifiedDate}
                useJobCodeKey={useJobCodeKey}
              />
            )}
          </React.Fragment>
        </div>
        <Modal ref={this.deleteModal} id="delete-match-modal" className="delete-match__modal" displayCloseButton={true}>
          {matchToDelete && (
            <React.Fragment>
              <ModalHeader>
                <h3>
                  Remove {jobPricingGrid.metadata.pricingType === PRICING_TYPE.SLOTTED ? 'Slotted' : 'Survey'} Job Match
                </h3>
              </ModalHeader>
              <ModalBody>
                Are you sure you want to remove &quot;
                <span className="match-job-title">{this.getPricingMatchTitleFromId(matchToDelete.matchId)}</span>&quot;?
                {isPricingMatchDeleteFailed && (
                  <div className="delete__error">
                    Error occurred while deleting the pricing match, please try again.
                  </div>
                )}
              </ModalBody>
              <ModalFooter
                cancelBtnClick={this.hideDeleteModal}
                submitBtnClick={this.deleteMatch}
                saveButtonDisabled={isPricingMatchDeleting}
                submitBtnTxtName={
                  isPricingMatchDeleting ? <i className="icon-animate-spin icon-spin" /> : 'Remove Match'
                }
              />
            </React.Fragment>
          )}
        </Modal>
      </div>
    );
  }
}

export default withRouter(JobPricingContainer);
